import { request } from './client';

export function listTags({ pagination = { limit: 100, offset: 0 } } = {}) {
  return request('/api/tag/v1/tags/list', {
    method: 'POST',
    body: JSON.stringify({ pagination }),
  });
}
